module.exports = __webpack_public_path__ + "static/media/boy-17.df5b6f63.svg";